import apiClient from '@u/apiClient'
import router from '@/router'
import Bugsnag from '@bugsnag/js'

export default {
  //region login
  // Resolves with whether the API authenticated the user.
  login({ commit }, loginData) {
    return (
      apiClient
        .get('/sanctum/csrf-cookie')
        // A 422 is shown by LoginForm (banner and field): no global toast.
        .then(() =>
          apiClient.post('/login', loginData.auth_form, {
            skipValidationToast: true
          })
        )
        .then((response) => {
          if (
            !(response.data && response.data.auth && response.data.expiration)
          ) {
            return false
          }
          commit('setAuth', {
            auth: response.data.auth,
            expiration: response.data.expiration
          })
          Bugsnag.leaveBreadcrumb('connection', response.data.auth.full_name)
          commit('settings/setSystemSettings', response.data.settings, {
            root: true
          })
          commit('setPermissions', response.data.auth)
          return true
        })
    )
  },
  //endregion

  //region logout
  async logout({ commit }) {
    // Ends the Sanctum session on the API. Not awaited: an expired session
    // (401/419) never settles, and the local logout must happen anyway.
    apiClient.post('/logout', null, { skipNotFoundToast: true }).catch(() => {})
    await commit('setAuth', { auth: {}, expiration: null, errors: [] })
    // Left by the former vuex-persistedstate.
    localStorage.removeItem('vuex')
    router.push({ name: 'login' })
  },
  //endregion

  //region refreshAuth
  // The user, their permissions and the system settings, from the API:
  // on MainLayout's mount, after saving settings, on a Pusher event.
  refreshAuth({ commit }) {
    // The XSRF cookie comes with every API response: no csrf-cookie call.
    return apiClient.get('api/refreshAuth').then((response) => {
      const auth = response.data.auth
      commit('setAuth', { auth, expiration: response.data.expiration })
      commit('setPermissions', auth)
      commit('settings/setSystemSettings', response.data.settings, {
        root: true
      })
      if (auth?.id) Bugsnag.setUser(auth.id, auth.email, auth.full_name)
      return response.data
    })
  },
  //endregion

  //region init pusher
  // Resolves with the Pusher key.
  initPusher() {
    return apiClient
      .get('api/getPusherKey')
      .then((response) => response.data.key)
  }
  //endregion
}
